// Session-scoped token storage. Tokens are re-issued on every mini-app launch
// from a fresh Telegram initData, so persistence beyond the session is useless
// and mildly dangerous.

const ACCESS_KEY = 'miniapp_access_token';
const REFRESH_KEY = 'miniapp_refresh_token';

export function getAccessToken(): string | null {
  return sessionStorage.getItem(ACCESS_KEY);
}

export function getRefreshToken(): string | null {
  return sessionStorage.getItem(REFRESH_KEY);
}

export function setTokens(access: string, refresh: string) {
  sessionStorage.setItem(ACCESS_KEY, access);
  sessionStorage.setItem(REFRESH_KEY, refresh);
}

export function clearTokens() {
  sessionStorage.removeItem(ACCESS_KEY);
  sessionStorage.removeItem(REFRESH_KEY);
}
